var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1295 1.99927C10.481 2.00428 10.8164 2.148 11.0625 2.39913L13.5949 4.93156C13.846 5.17765 13.9898 5.51299 13.9948 5.86456V12.6621C13.9948 13.0156 13.8543 13.3547 13.6044 13.6046C13.3544 13.8546 13.0154 13.995 12.6619 13.995H3.33188C2.97839 13.995 2.63937 13.8546 2.38941 13.6046C2.13945 13.3547 1.99902 13.0156 1.99902 12.6621V3.33213C1.99902 2.97863 2.13945 2.63961 2.38941 2.38965C2.63937 2.13969 2.97839 1.99927 3.33188 1.99927H10.1295Z",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3293 13.995V9.33C11.3293 9.15326 11.2591 8.98375 11.1341 8.85877C11.0092 8.73379 10.8397 8.66357 10.6629 8.66357H5.33147C5.15472 8.66357 4.98521 8.73379 4.86023 8.85877C4.73525 8.98375 4.66504 9.15326 4.66504 9.33V13.995",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66504 1.99927V4.66499C4.66504 4.84174 4.73525 5.01124 4.86023 5.13622C4.98521 5.2612 5.15472 5.33142 5.33147 5.33142H9.99648",
    stroke: "white",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.8fa3c300cd0237f11613a64483327ffb.svg";
export { ForwardRef as ReactComponent };